const C = require("../constants");

const choicePlan = plan => {
    return {
        type: C.SELECT_PLAN,
        plan
    }
};

export {choicePlan};


// WEBPACK FOOTER //
// ./src/actions/PlanesActions.js